import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  TextInput,
} from "react-admin";
import TabbedDatagrid from "./CourseTabbedDatagrid";

const courseFilters = [<TextInput label="Search" source="q" alwaysOn />];

const CourseList = (props) => (
  <List
    {...props}
    filters={courseFilters}
    perPage={25}
    filterDefaultValues={{ semesterId: "1" }}
  >
    <TabbedDatagrid />
  </List>
);

export default CourseList;
